import httpClient from "Api/httpClient";

const END_POINT = "/users";

const getCurrentUser = () => {
    let GET_END_POINT = END_POINT + "/current";
    return httpClient.get(GET_END_POINT); // useCahe: true, retryTimes: 3, throttle: true
};

export { getCurrentUser };
